import qs from 'qs';
import { saveAs } from 'file-saver';
import { FULL_DATE_FORMAT } from 'src/config/constants';
import moment from 'dayjs';

export const initAbortController = (): [() => AbortSignal, () => void] => {
    let controller: AbortController | null;

    return [
        () => {
            controller?.abort();
            return (controller = new AbortController()).signal;
        },
        () => {
            controller = null;
        },
    ];
};

export const stopPropagation = (ev) => {
    // eslint-disable-next-line no-unused-expressions
    ev?.preventDefault && ev.preventDefault();
    // eslint-disable-next-line no-unused-expressions
    ev?.stopPropagation && ev.stopPropagation();
};

export const parseObj = (obj: any, path: string): any => {
    const paths = (path || '').split('.');
    const tmp = paths.shift() || '';
    if (obj) {
        if (paths.length && obj.hasOwnProperty(tmp)) {
            return parseObj(obj[tmp], paths.join('.'));
        } else if (obj.hasOwnProperty(tmp)) {
            return obj[tmp];
        }
    }
    return null;
};

export const copyToClipboard = (text: string): void => {
    if (!navigator.clipboard) {
        return;
    }
    navigator.clipboard.writeText(text).then(
        () => {
            console.log('Async: Copying to clipboard was successful!');
        },
        (err) => {
            console.error('Async: Could not copy text: ', err);
        },
    );
};

export const onDisableScroll = () => {
    document.body.classList.add('disable-scroll');
};

export const onEnableScroll = () => {
    document.body.classList.remove('disable-scroll');
};

export const isValid = (validationForm: any, values: any): { /*isValid: boolean;*/ error: any } => ({
    /*isValid: Object.keys(validationForm).every((key) => {
        const tmp = validationForm[key];
        if (typeof tmp?.required === 'function') {
            return tmp.required(values[key], values);
        } else if (tmp?.required) {
            return !!values[key]?.toString().length;
        }
        return true;
    }),*/
    error: Object.keys(validationForm).reduce((res, key) => {
        const tmp = {};
        const { required: tmpRequired, pattern } = validationForm[key];
        const required = typeof tmpRequired === 'function' ? tmpRequired(values[key], values) : tmpRequired;

        if (required && !values[key]?.toString().length) {
            Object.assign(tmp, { required: true });
        }
        if (pattern) {
            if (typeof pattern === 'function') {
                if (!pattern(values[key], values) && (required || (!required && values[key]))) {
                    Object.assign(tmp, { pattern: true });
                }
            } else if (!pattern.test(values[key]) && (required || (!required && values[key]))) {
                Object.assign(tmp, { pattern: true });
            }
        }
        if (Object.keys(tmp).length) {
            res = res || {};
            res[key] = tmp;
        }
        return res;
    }, null as any),
});

export const getInputAttr = (ev: any): { name: string; value: any } => {
    const { name, type, value, checked } = ev.target;
    const valueField = type === 'checkbox' ? checked : type === 'number' && value.length ? Number(value) : value;
    return { name, value: valueField };
};

export const parseModelToForm = (values: any, mapBoolean?: string[]): any => {
    return Object.keys(values).reduce((res: any, field: string) => {
        res[field] = values[field] === null ? (mapBoolean?.includes(field) ? null : '') : values[field];
        return res;
    }, {});
};

export const parseEmptyField = (values: any): any => {
    if (Array.isArray(values)) {
        return values;
    }
    return Object.keys(values).reduce((res: any, field: string) => {
        const value = values[field];
        if (
            (typeof value === 'string' && !value?.length) ||
            (Array.isArray(value) && !value.length) ||
            value === undefined
        ) {
            res[field] = null;
        } else if (value && typeof value === 'object' && !(value instanceof Date)) {
            res[field] = parseEmptyField(value);
        } else {
            res[field] = value;
        }
        return res;
    }, {});
};

export const removeEmptyField = (values: any): any => {
    if (Array.isArray(values)) {
        return values;
    }
    return Object.keys(values).reduce((res: any, field: string) => {
        const value = values[field];
        if ((typeof value === 'string' && value?.length) || value) {
            res[field] = value;
        }
        return res;
    }, {});
};

export const parseQs = (search: string): any => {
    let parseKey = '';
    return qs.parse(search, {
        ignoreQueryPrefix: true,
        // parseArrays: true,
        comma: true,
        decoder(value, func: any, charset: string, type: any) {
            if (type === 'value') {
                const tmp = decodeURI(value);
                if (!parseKey.includes('search.') && /^(\d+|\d*\.\d+)$/.test(tmp)) {
                    // if (parseKey.includes('page')) {
                    return parseFloat(tmp);
                }
                if (['true', 'false'].includes(tmp)) {
                    return Boolean(tmp);
                }
                return tmp;
            } else {
                parseKey = value;
            }
            return value;
        },
    });
};

export const stringifyQs = (value: any): string => {
    const obj = Object.keys(value || {}).reduce((res: any, key: string) => {
        if (value[key] || value[key] === 0) {
            res[key] = value[key];
        }
        return res;
    }, {});
    return qs.stringify(obj, {
        encode: false,
        // arrayFormat: 'comma',
        arrayFormat: 'brackets',
        encodeValuesOnly: true,
    });
};

export const saveFile = (blobContent: any, fileName: string, responseType: string) => {
    const blob = new Blob([blobContent], {
        type: responseType ? responseType : 'application/octet-stream',
    });
    saveAs(blob, fileName);
};

export const parseValues = (values: any): any =>
    Object.keys(values || {}).reduce(
        (res, key) => {
            if (values[key] === null) {
                res[key] = undefined;
            }
            return res;
        },
        { ...values },
    );

export const getBooleanValue = (item: any, key: string) => (item && item[key] ? 'Так' : 'Ні');
export const displayBoolean = (value: boolean) => (value ? 'Так' : 'Ні');

export const formatDateFull = (date: Date | string | undefined): string =>
    date ? moment(date).format(FULL_DATE_FORMAT) : '-';

export default {};
